<template>
  <div class="forms-edit-map">
    <assets-offline-map
      mode="list"
      :map-config="mapConfig"
      :selected="selected"
      :can-view-summary="false"
      fetch-on="border"
      local-list
      :fetch-params="fetchParams"
      :contract-id="contractId"
      @select="onSelect"
      @asset-created="onAssetCreated"
      ref="assetsOfflineMap"
    >
      <template #detailHeaderButtons="{ close }">
        <b-button size="is-small" @click="close('list')">CLOSE</b-button>
      </template>
    </assets-offline-map>
  </div>
</template>

<script>
import AssetsOfflineMap from "@/components/AssetsOfflineMap";

export default {
  props: {
    center: {
      type: Object,
    },
    selected: {
      type: Object,
    },
    fetchParams: {
      type: Object,
      default: () => ({}),
    },
    contractId: {
      type: [String, Number],
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AssetsOfflineMap,
  },
  data: () => ({
    mapConfig: {
      height: 500,
      hasDrawControl: true,
      hasDrawToggleControl: true,
      hasLocateControl: true,
      hasOfflineControl: false,
      extendedBounds: 250,
      scrollable: true,
      scrollWheelZoom: false,
      clickable: true,
    },
  }),
  created() {
    this.mapConfig.clickable = !this.viewOnly;
    this.mapConfig.scrollable = !this.viewOnly;
    this.mapConfig.hasDrawControl = !this.viewOnly;
    this.mapConfig.hasDrawToggleControl = !this.viewOnly;
    this.mapConfig.hasLocateControl = !this.viewOnly;
  },
  watch: {
    center(center) {
      if (center) {
        if (this.$refs.assetsOfflineMap) {
          this.$refs.assetsOfflineMap.mapConfig_.center = center;
        }
      }
    },
  },
  methods: {
    onSelect(asset) {
      this.$emit("update:selected", asset);
    },
    onAssetCreated(asset) {
      this.$refs.assetsOfflineMap.selectFeature(asset.id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Forms/edit/partials/map.vue